// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

import { Capacitor } from "@capacitor/core";

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
let awsmobile: any = {
    'aws_cognito_identity_pool_id': 'ap-southeast-2:5ed04fd3-2f00-4b51-8cb7-4810edb5dfb3',
    'aws_cognito_region': 'ap-southeast-2',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'cardihabappprod-hosting-mobilehub-1942881221',
    'aws_content_delivery_bucket_region': 'ap-southeast-2',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'dag9fn5roi61g.cloudfront.net',
    'aws_mandatory_sign_in': 'enable',
    'aws_project_id': 'ef2f507d-207f-48ae-862e-118ef78e144d',
    'aws_project_name': 'cardihabapp-prod',
    'aws_project_region': 'ap-southeast-2',
    'aws_resource_name_prefix': 'cardihabappprod-mobilehub-1942881221',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'ap-southeast-2_d7Ic1KJxP',
    'aws_user_pools_web_client_id': '7td4ke2nqlq2jhh41n2cuh4n20',
}

if (!Capacitor.isNativePlatform()) {
    awsmobile = {
        'Auth': {'storage': window.sessionStorage},
        'authenticationFlowType': 'CUSTOM_AUTH',
        'aws_cognito_identity_pool_id': 'ap-southeast-2:5ed04fd3-2f00-4b51-8cb7-4810edb5dfb3',
        'aws_cognito_region': 'ap-southeast-2',
        'aws_content_delivery': 'enable',
        'aws_content_delivery_bucket': 'cardihabappprod-hosting-mobilehub-1942881221',
        'aws_content_delivery_bucket_region': 'ap-southeast-2',
        'aws_content_delivery_cloudfront': 'enable',
        'aws_content_delivery_cloudfront_domain': 'dag9fn5roi61g.cloudfront.net',
        'aws_mandatory_sign_in': 'enable',
        'aws_project_id': 'ef2f507d-207f-48ae-862e-118ef78e144d',
        'aws_project_name': 'cardihabapp-prod',
        'aws_project_region': 'ap-southeast-2',
        'aws_resource_name_prefix': 'cardihabappprod-mobilehub-1942881221',
        'aws_sign_in_enabled': 'enable',
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'ap-southeast-2_d7Ic1KJxP',
        'aws_user_pools_web_client_id': '7sv7dlndjvejuospc77cekhv4e',
    }
}

export default awsmobile;
